var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42773 6.75C2.42773 15.034 9.14373 21.75 17.4277 21.75H19.6777C20.2745 21.75 20.8468 21.5129 21.2687 21.091C21.6907 20.669 21.9277 20.0967 21.9277 19.5V18.128C21.9277 17.612 21.5767 17.162 21.0757 17.037L16.6527 15.931C16.2127 15.821 15.7507 15.986 15.4797 16.348L14.5097 17.641C14.2277 18.017 13.7407 18.183 13.2997 18.021C11.6626 17.4191 10.1759 16.4686 8.94252 15.2352C7.70914 14.0018 6.75861 12.5151 6.15673 10.878C5.99473 10.437 6.16073 9.95 6.53673 9.668L7.82973 8.698C8.19273 8.427 8.35673 7.964 8.24673 7.525L7.14073 3.102C7.07987 2.85869 6.93946 2.6427 6.74179 2.48834C6.54412 2.33397 6.30054 2.25008 6.04973 2.25H4.67773C4.081 2.25 3.5087 2.48705 3.08674 2.90901C2.66479 3.33097 2.42773 3.90326 2.42773 4.5V6.75Z",
    stroke: "#001E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.c486a22d3281d0c06184f70c6a0ad0ef.svg";
export { ForwardRef as ReactComponent };